import { ContactFiledInterface } from '@systemeio/ui'
import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactFieldCreateInterface } from 'modules/contacts/contact-page/types/contact-edit-interface'
import httpClient from 'shared/utils/http-client'

export const deleteField = (id: number) => httpClient.delete(`${CONTACT_API}/fields/${id}`)

export const addField = (data: ContactFieldCreateInterface) =>
  httpClient.post<ContactFiledInterface>(`${CONTACT_API}/fields`, data)

export const changeContactMarketingSubscriptionStatus = async (id: number, unsubscribed: boolean) =>
  httpClient.get(
    `${CONTACT_API}/contacts/${id}/${
      unsubscribed ? 'subscribe-to-marketing-emails' : 'unsubscribe-from-marketing-emails'
    }`,
  )

export const changeContactTransactionalSubscriptionStatus = async (id: number) =>
  httpClient.get(`${CONTACT_API}/contacts/${id}/subscribe-to-transactional-emails`)

export const debounceContact = async (id: number) =>
  httpClient.post(`${CONTACT_API}/contacts/${id}/debounce`)
